// extracted by mini-css-extract-plugin
export default {"tree-performance":"style_tree-performance__e7iu0","tag-number":"style_tag-number__0KKf1","tag-number-1":"style_tag-number-1__mwO86","tag-number-2":"style_tag-number-2__UV0VR"};